const productLabel = {
  GetProductLabel: () => ({
    getProductLabel: {
      product: {
        name: 'Orchestra',
        description: 'Sistema de interoperabilidade e visualização de informações e terapia intensiva hospitalar',
        version: '4.13.1',
        date: '2024-05-24',
        registrationNumber: '',
      },
      vendor: {
        name: 'Carenet Sistemas e Dispositivos S.A.',
        address: 'Rua Manoel Coelho, 500, Sala 1208, Bairro Centro, São Caetano do Sul, CEP: 09510-101',
        sac: 'suporte.orchestra@carenet.com.br',
        whatsapp: '+55 11 94506-9938',
        qualifiedPerson: {
          name: 'Salvador Sergi Agati',
          licenseNumber: 'CREA: 0601099149 - SP',
        },
      },
    },
  }),
};

export default productLabel;
